import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import { Link } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import Select from "react-select";
import DataTable from "react-data-table-component";
//needs
import Web3 from "web3";
import * as utils from "web3-utils";
import network from "../../lib/AdminNetwork";
import { useDispatch, useSelector } from "react-redux";
import {
  addTokenCall,
  getCurrencyList,
  ServiceFeeaction,
} from "../../actions/users";
import { toast } from "react-toastify";
import config from "../../lib/config";
import Market from "../../ABI/market.json";
import { Account_Connect } from "../../actions/redux/action";
import { isEmpty } from "../../actions/commonFunction";
let toasterOption = config.toasterOption;

const CurrencyAdd = () => {
  const dispatch = useDispatch();
  const Wallet_Details = useSelector((state) => state.wallet_connect_context);
  const [Accounts, Set_Accounts] = useState("");
  const [currentChainId, SetCurrentChainId] = useState("");
  const [modalOpen, setmodalopen] = useState(false);
  const [ethtokenList, setethTokenList] = useState([]);
  const [bnbtokenList, setbnbTokenList] = useState([]);

  const options = [
    { value: "ETH", label: "ETH" },
    { value: "BNB", label: "BNB" },
  ];

  const [owner_Get, set_Owner_Get] = useState("");

  const GetContractServiceFee = async () => {
    
    if (Wallet_Details?.networkConfiguration?.TradeContract) {
      try {
        var web3 = new Web3(Wallet_Details.networkConfiguration.BNBPROVIDER);
        var Contract = new web3.eth.Contract(
          Market,
          Wallet_Details.networkConfiguration.TradeContract
        );
        
        var ownerGet = await Contract.methods.owner().call();
        var ownget = String(ownerGet).toLowerCase();
        
        set_Owner_Get(ownget);
      } catch (err) {
        console.error("GetContractServiceFee_error", err);
      }
    }
  };

  useEffect(() => {
    getConnect();
    GetContractServiceFee();
    SetCurrentChainId(Wallet_Details.networkConfiguration.Chainid);
  }, [
    Wallet_Details.UserAccountAddr,
    Wallet_Details.networkConfiguration.Chainid,
  ]);

  const getConnect = async () => {
    try {
      var configdata = {};
      if (window.ethereum) {
        var web3 = new Web3(window.ethereum);
        if (web3 !== undefined) {
          await window.ethereum.enable().then(async function () {
            const web3 = new Web3(window.web3.currentProvider);
            let connectedchainid = await web3.eth.getChainId();

            if (connectedchainid == network.BSC.networkVersion) {
              var currentChainId = network.BSC.Chainid;
              configdata = network.BSC;
            } else if (connectedchainid == network.ETH.networkVersion) {
              var currentChainId = network.ETH.Chainid;
              configdata = network.ETH;
            }
            
            if (connectedchainid == currentChainId) {
            
              if (window.ethereum.isMetaMask === true) {
                if (web3 && web3.eth) {
            
                  var result = await web3.eth.getAccounts();
                  var setacc = result[0].toLowerCase();
            

                  Set_Accounts(setacc);
                  
                  dispatch({
                    type: "Account_Connect",
                    Account_Detail: {
                      UserAccountAddr: setacc,
                      WalletConnected: "true",
                      Accounts: setacc,
                      providerss: window.ethereum,
                      networkConfiguration: configdata,
                      web3: web3,
                    },
                  });
                }
              }
            } else {
              toast.warning(
                "Please change your network to binance or ethereum",
                toasterOption
              );
            }
          });
        }
      }
    } catch (errr) {
      console.error("getconnect_error", errr);
    }
  };

  const serfeeall = () => {
    setmodalopen(true);
  };

  const disconnect = () => {
    Set_Accounts("");
  };

  const changeNetwork = async (chainid) => {
    
    if (window.ethereum.isMetaMask == true) {
      var web3 = new Web3(window.ethereum);
      var networkConfiguration = "";
      var web3Obj = await SwitchNetwork(chainid);
      
      //  const id=toast.loading("Wallet Connecting...")

      const accounts = await web3Obj.eth.getAccounts();
      

      if (accounts != "") {
        const IDcheck = await web3.eth.getChainId();

        if (IDcheck === network.ETH.Chainid) {
          networkConfiguration = network.ETH;
        } else if (IDcheck === network.BSC.Chainid) {
          networkConfiguration = network.BSC;
        }
        dispatch({
          type: Account_Connect,
          Account_Detail: {
            UserAccountAddr: accounts,
            WalletConnected: "true",
            Accounts: accounts,
            providerss: window.ethereum,
            networkConfiguration: networkConfiguration,
            web3: web3,
          },
        });
      }

      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };

  async function SwitchNetwork(chainid) {
    var web3;
    try {
      if (window.ethereum) {
        web3 = new Web3(window.ethereum);
        
        if (window.ethereum.isMetaMask == true) {
          const chainId = await web3.eth.getChainId();
          

          var configchainid =
            parseInt(chainid ?? chainId) === network.BSC.Chainid
              ? network.BSC.Chainid
              : network.ETH.Chainid;

          if (parseInt(chainId) != parseInt(configchainid)) {
            chainIdCheck(configchainid);
            return web3;
          }
        } else {
          alert("Please Uninstall CoinbaseWallet or Connect to Coinbase");
          return false;
        }
      } else {
      }
    } catch (e) {}
    
    return web3;
  }

  const chainIdCheck = async (configchainid) => {
    var Config = {};

    if (configchainid === network.ETH.Chainid) {
      Config = network.ETH;
    } else if (configchainid === network.BSC.Chainid) {
      Config = network.BSC;
    }
    const hexString = configchainid && configchainid.toString(16);
    
    if (window.ethereum) {
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
        });
        return true;
      } catch (error) {
        if (error.code === 4902) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x" + hexString,
                  rpcUrl: Config.RPC_URL,
                },
              ],
            });
            return true;
          } catch (addError) {
            
            console.error('chainIdCheck_add_error',addError);
          }
        }
        console.error('chainIdCheck_error',error);
      }
    } else {
      return false;
    }
  };

  const deletetoken = async (data) => {
    data.action = "delete";
    var resp = await addTokenCall(data);
    if (resp?.status) {
      toast.success(resp.msg);
      getTokenList();
    } else {
      toast.error(resp.msg);
    }
  };

  const columns = owner_Get == Wallet_Details?.UserAccountAddr ? 
  [
    {
      key: "ind",
      name: "SNO",
      // className: "name",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{index + 1}</p>,
    },
    {
      key: "tokenSymbol",
      name: "Token Name",
      className: "NFT NAME",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{row?.tokenSymbol}</p>,
    },
    {
      key: "tokenAddress",
      name: "Token Address",
      className: "NFT IDT",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{row?.tokenAddress}</p>,
    },
    {
      key: "delete",
      name: "Show / Hide Token",
      className: "NFT IDT",
      align: "left",
      sortable: false,
      cell: (record) => (
        <div>
          <button className="btn allbtn" onClick={() => deletetoken(record)}>
            {record.deleted ? "SHOW" : "HIDE"}
          </button>
        </div>
      ),
    },
  ] : 
  [
    {
      key: "ind",
      name: "SNO",
      // className: "name",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{index + 1}</p>,
    },
    {
      key: "tokenSymbol",
      name: "Token Name",
      className: "NFT NAME",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{row?.tokenSymbol}</p>,
    },
    {
      key: "tokenAddress",
      name: "Token Address",
      className: "NFT IDT",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{row?.tokenAddress}</p>,
    }
  ]

  useEffect(() => {
    getTokenList();
  }, []);

  const getTokenList = async () => {
    var resp = await getCurrencyList();

    if (resp?.status) {
      let eth = resp?.data.filter(
        (item) => item.chainId == Number(network.ETH.Chainid)
      );
      let bnb = resp?.data.filter(
        (item) => item.chainId == Number(network.BSC.Chainid)
      );
      
      // setTokenList(resp?.msg[0]?.CurrencyDetails)
      setethTokenList(eth[0]?.Token);
      setbnbTokenList(bnb[0]?.Token);
    }
  };

  const onchange = (e) => {
    // e.preventDefault()

    changeNetwork(e == "BNB" ? network.BSC.Chainid : network.ETH.Chainid);
    // setChainid(e)
  };

  const customStyles = {
    option: (styles) => ({
      ...styles,
      cursor: "pointer",
    }),
  };
  return (
    <Layout>
      <div className="servicefeeedit">
        <div
          className="text-end"
        >
          <Link
          onClick={() => (Accounts == "" ? getConnect() : disconnect())}
          to="#" className="btn sitebtn mb-4 py-2 px-3">
            {Accounts != "" ? Accounts : "Connect"}
          </Link>
        </div>
        <h1 className="pagehead">Currency List</h1>
        <div className="cardbox">
          <Select
            styles={customStyles}
            options={options}
            value={{
              value: currentChainId ? currentChainId : "Please Select Network",
              label: currentChainId
                ? currentChainId == network.BSC.networkVersion
                  ? "BSC Network"
                  : "Sepolia Network"
                : "Please Select Network",
            }}
            onChange={(e) => {
              onchange(e.value);
            }}
          />

          {!currentChainId ? (
            ""
          ) : currentChainId && currentChainId == network.BSC.networkVersion ? (
            <>
              {owner_Get == Wallet_Details?.UserAccountAddr && (
                <Link
                  to={{ pathname: `/addtoken` }}
                  state={{ chain: currentChainId }}
                >
                  <button className="btn sitebtn mt-3 mb-3 py-2 px-3" type="button">
                    Add Token
                  </button>
                </Link>
              )}
              <div className="table-responsive mt-2">
                <DataTable
                  className="react-datatables"
                  columns={columns}
                  data={bnbtokenList}
                  pagination // Enable pagination
                  // paginationPerPage={2} // Rows per page
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                />
              </div>
            </>
          ) : (
            <>
              {owner_Get == Wallet_Details?.UserAccountAddr && (
                <Link
                  to={{ pathname: `/addtoken` }}
                  state={{ chain: currentChainId }}
                >
                  <button className="btn sitebtn mt-3 mb-3 py-2 px-3" type="button">
                    Add Token
                  </button>
                </Link>
              )}
              <div className="table-responsive mt-2">
                <DataTable
                  className="react-datatables"
                  columns={columns}
                  data={ethtokenList}
                  pagination // Enable pagination
                  // paginationPerPage={2} // Rows per page
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CurrencyAdd;
